import React from "react";
import { Col, Form, Input, Row } from "antd";
import * as R from "ramda";

import { getJsonSchemaFromPath } from "@arachnys/flow-app/src/util";
import { Fieldset } from "@arachnys/styleguide/Fieldset";
import SchemaSelect from "@arachnys/styleguide/SchemaSelect";

const CUSTOMER_INTERNAL = "INTERNAL";

const RequestDetails = ({
    customerType,
    getFieldDecorator,
    disabled,
    researchRequest,
    researchRequestSchema,
}) => {
    const isInternal = customerType === CUSTOMER_INTERNAL;

    const requestTypeSchema = getJsonSchemaFromPath(
        "RequestType",
        researchRequestSchema
    );

    const clientTypeSchema = getJsonSchemaFromPath(
        "ClientType",
        researchRequestSchema
    );

    const serviceLineSchema = getJsonSchemaFromPath(
        "ServiceLine",
        researchRequestSchema
    );

    const monitoringTypeSchema = getJsonSchemaFromPath(
        "MonitoringType",
        researchRequestSchema
    );

    return (
        <Fieldset>
            <Row gutter={24}>
                <Col span={12}>
                    {!isInternal && (
                        <Form.Item label="Request Type">
                            {getFieldDecorator("request_type", {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            "Please specify the type of report you are requesting",
                                    },
                                ],
                                initialValue: R.prop(
                                    "requestType",
                                    researchRequest
                                ),
                            })(
                                <SchemaSelect
                                    schema={requestTypeSchema}
                                    placeholder="Request Type"
                                    disabled={disabled.request_type}
                                />
                            )}
                        </Form.Item>
                    )}
                    {isInternal && (
                        <Form.Item label="Service Line">
                            {getFieldDecorator("business_unit", {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            "Please specify the service line you are requesting",
                                    },
                                ],
                                initialValue: R.prop(
                                    "businessUnit",
                                    researchRequest
                                ),
                            })(
                                <SchemaSelect
                                    schema={serviceLineSchema}
                                    placeholder="Service Line"
                                    disabled={disabled.business_unit}
                                />
                            )}
                        </Form.Item>
                    )}
                </Col>
                <Col span={12}>
                    {!isInternal && (
                        <Form.Item label="Business Unit">
                            {getFieldDecorator("business_unit", {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            "Please enter the relevant business unit",
                                    },
                                ],
                                initialValue: R.prop(
                                    "businessUnit",
                                    researchRequest
                                ),
                            })(
                                <Input
                                    placeholder="Business Unit"
                                    disabled={disabled.business_unit}
                                />
                            )}
                        </Form.Item>
                    )}
                    {isInternal && (
                        <Form.Item label="Client Type">
                            {getFieldDecorator("request_type", {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            "Please enter the desired client type",
                                    },
                                ],
                                initialValue: R.prop(
                                    "requestType",
                                    researchRequest
                                ),
                            })(
                                <SchemaSelect
                                    schema={clientTypeSchema}
                                    placeholder="Client Type"
                                    disabled={disabled.client_type}
                                />
                            )}
                        </Form.Item>
                    )}
                    {isInternal && (
                        <Form.Item label="Billing Code">
                            {getFieldDecorator("billing_code", {
                                rules: [
                                    {
                                        required: true,
                                        message:
                                            "Please enter the billing code",
                                    },
                                ],
                                initialValue: R.prop(
                                    "billingCode",
                                    researchRequest
                                ),
                            })(
                                <Input
                                    placeholder="Billing Code"
                                    disabled={disabled.billing_code}
                                />
                            )}
                        </Form.Item>
                    )}
                </Col>
                {disabled.monitoring_type && (
                    <Col span={12}>
                        <Form.Item label="Monitoring Type">
                            {getFieldDecorator("monitoring_type", {
                                rules: [],
                                initialValue: R.prop(
                                    "monitoringType",
                                    researchRequest
                                ),
                            })(
                                <SchemaSelect
                                    schema={monitoringTypeSchema}
                                    placeholder="Monitoring Type"
                                    disabled={disabled.monitoring_type}
                                />
                            )}
                        </Form.Item>
                    </Col>
                )}
            </Row>
        </Fieldset>
    );
};

export default RequestDetails;
